import React, { Fragment } from "react"
import * as styles from "./FooterDetails.module.css"
import InputEmail from "../InputEmail/InputEmail"
import YoutubeSVG from "../../../../images/youtube.inline.svg"
import FaceBookSVG from "../../../../images/facebook.inline.svg"
import LinkedinSVG from "../../../../images/linkedin.inline.svg"
import { Link } from "gatsby"
import useDeviceType from "../../../../hooks/useDeviceType"

type FooterProps = {
  name?: string
  slug: string
  section: string
}

const FooterDetails = ({ name, slug, section }: FooterProps) => {
  //
  const deviceType = useDeviceType()

  const solutionPages = [
    { name: "PXP Retail", to: "/solutions/retail" },
    { name: "PXP Hospitality", to: "/solutions/hospitality" },
    { name: "PXP Restaurant", to: "/solutions/restaurant" },
    { name: "PXP Healthcare", to: "/solutions/healthcare" },
    { name: "PXP Property & Facility", to: "/solutions/property" },
    { name: "PXP Transportation", to: "/solutions/transportation" },
    { name: "Deskless Employee", to: "/solutions/deskless-employee" },
  ]

  const mainPages = [
    { name: "Insights", to: "/products/dashboard" },
    { name: "Collectors", to: "/products/feedback-kiosk-smiley-terminal" },
    { name: "Roles", to: "/roles/customer/cx-professional" },
    { name: "Employee Experience", to: "/solutions/deskless-employee" },
  ]

  const otherPages = [
    { name: "Blog", to: "/blog" },
    { name: "Pricing", to: "/pricing" },
    { name: "FAQ", to: "/faq" },
    { name: "Privacy Policy", to: "/privacy-policy" },
    { name: "Terms of Use", to: "/terms-and-conditions" },
    { name: "Contact Us", to: "/contact" },
  ]

  const removeExtraWords = (name: string) => {
    if (name.length > 1 && deviceType === "mobile") return name.split(" ")[0]
    return name
  }

  const currentDate = new Date()
  const currentYear = currentDate.getFullYear()

  return (
    <div className={styles.container}>
      <div className={styles.backgroundBlur} />

      <div>
        <div className={styles.inputContent}>
          <h4>Subscribe to our newsletter to stay in touch with the latest.</h4>
          <InputEmail name={name} url={slug} section={section} />
        </div>

        <div className={styles.iconsContent}>
          <div className={styles.icons}>
            <Link
              to="https://www.linkedin.com/company/pressnxpress"
              target="_blank"
              rel="noreferrer"
              aria-label="Linkedin"
            >
              <LinkedinSVG />
            </Link>
            <Link to="https://www.facebook.com/pressnxpress">
              <FaceBookSVG />
            </Link>
            <Link to="https://www.youtube.com/@pressnxpress">
              <YoutubeSVG />
            </Link>
          </div>
          <div className={styles.address}>
            <span>Markham, ON, Canada</span>
            <span>Los Angeles, CA , United States</span>
          </div>
        </div>
      </div>

      {/* Soluton Pages */}
      <div className={styles.LinksContent}>
        <div className={styles.solutions}>
          <h4>Solutions</h4>
          {solutionPages.map(({ name, to }) => (
            <Link key={name} to={to}>
              {name}
            </Link>
          ))}
        </div>

        {/* Main Pages */}
        <div className={styles.pagesContent}>
          {mainPages.map(({ name, to }) => (
            <Link key={name} to={to}>
              {name}
            </Link>
          ))}
        </div>
      </div>

      {/* Other Pages */}
      <div className={styles.otherPagesContent}>
        {otherPages.map(({ name, to }) => (
          <Fragment key={name}>
            <Link to={to}>{removeExtraWords(name)}</Link>
            <span>|</span>
          </Fragment>
        ))}

        <p className={styles.copyRight}>
          Copyright © {currentYear} Discrete Choice Inc. All Rights Reserved.
        </p>
      </div>
    </div>
  )
}

export default FooterDetails
